<template>
  <section class="case-creation" v-loading="loading">
    <div class="container-sm">
      <!-- ! Patient Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Patient Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <div style="display: flex;  gap: 12px; font-family: sans-serif; ">
   <div>
    <p style="margin: 0; font-weight: 500;   ">STAT Case</p>
</div>
<div>
        <label
      style="position: relative; display: inline-block; width: 50px; height: 28px;"
    >
      <input
        type="checkbox"
        v-model="caseInformation.is_stat"
        style="opacity: 0; width: 0; height: 0;"
      />
      <span
        :style="`
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 20px;
          width: 36px;
          background-color: ${caseInformation.is_stat ? '#4ade80' : '#f2f2f2'};
          border : ${caseInformation.is_stat ? '#4ade80' : '#f2f2f2'};
          border-radius: 34px;
          transition: 0.4s;
          display: flex;
          align-items: center;
          padding: 0 4px;
        `"
      >
        <span
          :style="`
            height: 20px;
            width: 20px;
            background-color: ${caseInformation.is_stat ? '#f2f2f2' : 'white'};
            border-radius: 50%;
            transition: 0.4s;
            transform: translateX(${caseInformation.is_stat ? '22px' : '0'});
          `"
        ></span>
      </span>
    </label>
      </div>
    </div>
              <el-form :model="patientInformation" ref="ruleForm">
                <el-row :gutter="15">
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          First Name
                          <span class="star">*</span>
                        </label>

                        <el-input
                          v-model="patientInformation.first_name"
                          placeholder="Enter First Name"
                          class="el-input"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.first_name"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Middle Name</label>
                        <el-input
                          v-model="patientInformation.middle_name"
                          placeholder="Enter Middle Name"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.middle_name"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Last Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="patientInformation.last_name"
                          placeholder="Enter Last Name"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.last_name"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Gender
                          <span class="star">*</span>
                        </label>
                        <div class="gender-select">
                          <el-select
                            filterable
                            v-model="patientInformation.gender"
                            placeholder="Gender"
                            default-first-option
                            clearable
                            @change="handlePregnancyData"
                            
                          >
                            <el-option
                              v-for="(gender, index) in genderOptions"
                              :key="index"
                              :label="gender"
                              :value="gender"
                            ></el-option>
                          </el-select>
                        </div>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.gender"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="date-of-birth case-creation__input">
                      <dobVersion
                        v-if="showPatientDob"
                        :dobData="patientInformation"
                        :validataionErrors="getErrors"
                        :errorKey="'patient_info.date_of_birth'"
                        ref="dobField"
                      ></dobVersion>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">EMR</label>
                        <el-input
                          v-model="patientInformation.emr"
                          placeholder="Enter EMR"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.emr"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input mobile-icon">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Mobile Number
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="patientInformation.home_phone"
                          placeholder="Enter Mobile Number"
                          maxlength="10"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.home_phone"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input mobile-icon">
                      <el-form-item class="mb-0">
                        <label for="text">Phone Number</label>
                        <el-input
                          v-model="patientInformation.work_phone"
                          placeholder="Enter Phone Number"
                          maxlength="10"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.work_phone"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="7" :lg="7" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Email</label>
                        <el-input
                          v-model="patientInformation.email"
                          placeholder="Enter Email"
                          class="el-input email-lower"
                          type="email"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.email"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="7" :lg="7" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Address Line 1
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="patientInformation.address_line_1"
                          placeholder="Enter Address Line 1"
                          class="el-input"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.address_line_1"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Address Line 2</label>

                        <el-input
                          v-model="patientInformation.address_line_2"
                          placeholder="Enter Address Line 2"
                          class="el-input"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.address_line_2"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="15">
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Zip
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="patientInformation.zip"
                          placeholder="Enter Zip"
                          maxlength="5"
                          @input="getStateCity"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.zip"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="date-of-birth case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">County</label>
                        <el-input
                          placeholder="Enter County"
                          v-model="patientInformation.county"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.county"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="date-of-birth case-creation__input">
                      <el-form-item>
                        <state
                          v-show="showDob"
                          :stateData="patientInformation"
                        ></state>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.state"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="date-of-birth case-creation__input">
                      <el-form-item>
                        <city
                          v-if="showDob"
                          :cityData="patientInformation"
                        ></city>
                        <p class="err">
                          <FormError
                            errorName="case_data.patient_info.city"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">&nbsp;</label>
                        <div class="verify-address-btn">
                          <el-button
                            :disabled="hasAddress"
                            @click="verifyAddress"
                            :loading="verifyButtonLoading"
                            >Verify Address</el-button
                          >
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Race</label>
                        <div class="gender-select">
                          <el-select
                            v-model="patientInformation.race"
                            placeholder="Select Race"
                            filterable
                            default-first-option
                            :reserve-keyword="false"
                            clearable
                            
                          >
                            <el-option
                              v-for="(race, index) in raceOptions"
                              :key="index"
                              :label="race"
                              :value="race"
                            ></el-option>
                          </el-select>
                        </div>
                        <p class="err">
                          <FormError errorName="patient_info.race"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Ethnicity</label>
                        <div class="gender-select">
                          <el-select
                            v-model="patientInformation.ethnicity"
                            placeholder="Select Ethnicity"
                            filterable
                            default-first-option
                            :reserve-keyword="false"
                            clearable
                            
                          >
                            <el-option
                              v-for="(ethnicity, index) in ethnicityOptions"
                              :key="index"
                              :label="ethnicity"
                              :value="ethnicity"
                            ></el-option>
                          </el-select>
                        </div>
                        <p class="err">
                          <FormError
                            errorName="patient_info.ethnicity"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col
                    :xl="4"
                    :lg="3"
                    :md="8"
                    :sm="12"
                    :xs="12"
                    v-if="patientInformation.gender == 'FEMALE'"
                  >
                    <div class="pregancy-field">
                      <label for="">Pregnancy </label>
                      <el-form-item class="text mb-0">
                        <el-checkbox
                          class="el-checkbox-group"
                          v-model="patientInformation.pregnant"
                          size="large"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div class="case-creation__footer">
            <div class="patient-details">
              <el-button
                class="look-up-button btn"
                type="text"
                @click="openLookUpDialog()"
                >Lookup</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider"></span>

      <!-- ! Case Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Case Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <el-form :model="caseInformation">
                <el-row :gutter="15">
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Case type
                          <span class="star">*</span>
                        </label>
                        <el-select
                          multiple
                          v-model="caseInformation.case_types"
                          placeholder="Select Case type"
                          filterable
                          :multiple-limit="getCaseTypeLimit"
                          @change="addSpecimenCaseTypes"
                          
                        >
                          <el-option
                            v-for="(caseType, index) of getCaseTypes"
                            :key="index"
                            :value="caseType.value"
                            :label="caseType.case_name"
                            :disabled="checkCaseTypeDisable(caseType)"
                          ></el-option>
                        </el-select>
                        <span
                          class="selected-case-types"
                          v-for="(
                            caseTypeVal, index
                          ) in caseInformation.case_types"
                          :key="index"
                        ></span>
                        <p class="err">
                          <FormError
                            errorName="case_data.case_types"
                          ></FormError>
                        </p>
                        <div
                          class="case-select-types"
                          :class="{
                            'active-case-type-error': isError,
                          }"
                        >
                          <p
                            class="selected-case-types"
                            v-for="(
                              caseTypeVal, index
                            ) in caseInformation.case_types"
                            :key="index"
                          >
                            {{ caseTypeMap[caseTypeVal] || caseTypeVal }}
                          </p>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Laboratory
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Laboratory"
                          disabled
                          v-model="caseInformation.lab"
                          filterable
                        >
                          <el-option
                            v-for="(lab, index) of getAllLabs"
                            :key="index"
                            :value="lab._id"
                            :label="lab.name"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="case_data.lab"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Collection Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker
                          type="datetime"
                          v-model="caseInformation.collection_date"
                          placeholder="MM-DD-YYYY HH:MM AM"
                          format="MM-DD-YYYY hh:mm A"
                          :disabled-date="disabledDate"
                          :default-time="defaultTime"
                        ></el-date-picker>
                        <p class="err">
                          <FormError
                            errorName="case_data.collection_date"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Received Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker
                          type="datetime"
                          v-model="caseInformation.received_date"
                          placeholder="MM-DD-YYYY HH:MM AM"
                          format="MM-DD-YYYY hh:mm A"
                          :disabled-date="disabledDate"
                          :default-time="defaultTime"
                        ></el-date-picker>
                        <p class="err">
                          <FormError
                            errorName="case_data.received_date"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Ordering Facility
                          <span class="star">*</span>
                        </label>
                        <el-select
                          v-model="caseInformation.hospital"
                          placeholder="Select Ordering Facility"
                          @change="fetchAllPhysiciansByHospital"
                          clearable
                          filterable
                          default-first-option
                        >
                          <el-option
                            v-for="(hospital, index) of hospitalsData.data"
                            :key="index"
                            :value="hospital._id"
                            :label="hospital.name"
                            :disabled="isInactiveStatus(hospital)"
                          >
                            <span style="float: left">{{ hospital.name }}</span>
                            <span
                              v-if="isInactiveStatus(hospital)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="case_data.hospital"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Ordering Facility Branch</label>
                        <el-select
                          placeholder="Select Ordering Facility Branch"
                          @change="fetchAllPhysiciansByHospitalBranch"
                          v-model="caseInformation.hospital_branch"
                          clearable
                          filterable
                          default-first-option
                        >
                          <el-option
                            v-for="(hospital, index) of hospitalBranches"
                            :key="index"
                            :value="hospital._id"
                            :label="hospital.display_name"
                            :disabled="isInactiveStatus(hospital)"
                          >
                            <span style="float: left">
                              {{ hospital.display_name }}
                            </span>
                            <span
                              v-if="isInactiveStatus(hospital)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError
                            errorName="case_data.facility_branch"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Ordering Physician
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Ordering Physician"
                          v-model="caseInformation.ordering_physician"
                          clearable
                          filterable
                          default-first-option
                          
                        >
                          <el-option
                            v-for="physician in physiciansData.data"
                            :key="physician._id"
                            :label="physician.name"
                            :value="physician._id"
                            :disabled="isInactiveStatus(physician)"
                          >
                            <span style="float: left">
                              {{ physician.name }}
                            </span>
                            <span
                              v-if="isInactiveStatus(physician)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 15px;
                              "
                              >Inactive</span
                            >
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError
                            errorName="case_data.ordering_physician"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Referring Physician</label>
                        <el-select
                          v-model="caseInformation.referring_physician"
                          placeholder="Select Referring Physician"
                          clearable
                          filterable
                          default-first-option
                          
                        >
                          <el-option
                            v-for="physician in allReferringPhysicians"
                            :key="physician._id"
                            :label="physician.name"
                            :value="physician._id"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError
                            errorName="case_data.referring_physician"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Bill To
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Bill To"
                          clearable
                          v-model="caseInformation.billing_type"
                          filterable
                          default-first-option
                          
                        >
                          <el-option
                            class="referring-physician-options"
                            label="INSURANCE"
                            value="INSURANCE"
                          ></el-option>
                          <el-option
                            label="PATIENT"
                            value="PATIENT"
                          ></el-option>
                          <el-option label="CLIENT" value="CLIENT"></el-option>
                          <el-option
                            label="LABCORP"
                            value="LABCORP"
                          ></el-option>
                          <!-- <el-option
                            label="SENDOUT"
                            value="SENDOUT"
                          ></el-option> -->
                        </el-select>
                        <p class="err">
                          <FormError
                            errorName="case_data.billing_type"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Order Id</label>
                        <el-input
                          type="text"
                          placeholder="Enter Order Id"
                          v-model="caseInformation.order_id"
                          :rows="3"
                          
                          disabled
                        ></el-input>
                        <p class="err">
                          <FormError errorName="case_data.order_id"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Specimen Collector</label>
                        <el-input
                          placeholder="Enter Specimen Collector"
                          v-model="caseInformation.specimen_collector"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.specimen_collector"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="16" :lg="16" :md="3" :sm="6" :xs="6">
                    <div class="case-creation__input">
                      <el-form-item>
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            column-gap: 2rem;
                          "
                        >
                          <label for="text">
                            ICD-10 ( Indicative )
                            <span class="star">*</span>
                          </label>
                          <el-checkbox
                            class="el-checkbox-icd"
                            style="
                              display: flex;
                              align-items: center;
                              height: 14px;
                            "
                            v-model="includeAllICDCodes"
                            >Include All ICD Codes</el-checkbox
                          >
                        </div>

                        <div class="ten-icd-group d-flex">
                          <div
                            class="each-input mr-5"
                            v-for="(
                              icdCode, index
                            ) of caseInformation.icd_10_codesForm"
                            :key="index"
                          >
                            <el-autocomplete
                              placeholder="CODE"
                              v-model="icdCode.value"
                              popper-class="ten-icd-popper"
                              :fetch-suggestions="getAutoCompleteICDData"
                              @select="selectICDCode($event, icdCode)"
                            >
                              <template #default="{ item }">
                                <div class="icd-dropdown-style">
                                  <span class="code pr-5">
                                    {{ item.code }}
                                  </span>
                                  <span class="desc pl-5">
                                    {{ item.description }}
                                  </span>
                                </div>
                              </template>
                            </el-autocomplete>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="icd_10_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="24" :lg="24" v-if="!isBillingUser">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"> CPT Codes </label>

                        <div class="ten-icd-group d-flex">
                          <div
                            class="each-input mr-5"
                            v-for="(
                              cptCode, index
                            ) of caseInformation.cpt_codesForm"
                            :key="index"
                          >
                            <el-input
                              placeholder="CODE"
                              v-model="cptCode.value"
                              popper-class="ten-icd-popper"
                              :disabled="isBillingUser"
                            >
                            </el-input>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="cpt_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col
                    :xl="8"
                    :lg="8"
                    :md="3"
                    :sm="6"
                    :xs="6"
                    v-if="
                      caseInformation.case_types &&
                      caseInformation.case_types.length
                    "
                  >
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Specimen Types
                          <span class="star">*</span>
                        </label>

                        <div
                          class="specimen-case-type"
                          v-for="(type, index) in this.caseInformation
                            .sample_types"
                          :key="index"
                        >
                          <span class="case-name">
                            {{ caseTypeMap[type.case_type] }}
                          </span>
                          <span class="custom-select-capitalize">
                            <el-select
                              v-model="type.sample_types"
                              multiple
                              filterable
                              allow-create
                              :reserve-keyword="false"
                              default-first-option
                              @change="addNewSampleType"
                              @focus="fetchSpecimenTypes"
                              popper-class="custom-select-dropdown"
                              
                            >
                              <el-option
                                v-for="(specimen, index) in getAllSampleTypes"
                                :key="index"
                                :label="specimen.sample_type.toLowerCase()"
                                :value="specimen.sample_type"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                :errorName="`case_data.sample_types.${index}.sample_types`"
                              ></FormError>
                            </p>
                          </span>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Additional Fax Receiver Name</label>
                        <el-input
                          placeholder="Enter Additional Fax Receiver Name"
                          v-model="caseInformation.additional_fax_requisite"
                          
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="case_data.additional_fax_requisite"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="16" :lg="12" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <div class="additonal-fax">
                          <div>
                            <label for="text">Additional Fax</label>
                            <el-input
                              maxlength="10"
                              v-model="faxInputValue"
                              placeholder="Enter Additional Fax "
                              class="el-input"
                              @keyup.enter.prevent="handleInputConfirm"
                              
                            ></el-input>
                            <p class="err">
                              <FormError
                                errorName="case_data.additional_fax"
                              ></FormError>
                            </p>
                          </div>
                          <div class="fax-btn">
                            <el-button @click="handleInputConfirm">
                              <span>+ New Fax</span>
                            </el-button>
                            <div class="fax-actions-view">
                              <el-tag
                                class="mr-10"
                                v-for="tag in caseInformation.additional_fax"
                                :key="tag"
                                :disable-transitions="false"
                              >
                                <span class="btn-close-icon">
                                  {{ tag }}
                                  <img
                                    @click="handleFaxRemove(tag)"
                                    src="@/assets/images/fax-tag-close.svg"
                                    alt="icon"
                                  />
                                </span>
                              </el-tag>
                            </div>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider"></span>
      <!-- ! Test Information || Case Creation -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__card">
          <div class="text-information-card">
            <div class="case-creation__heading border-bottom-none">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Test Information</h3>
              </div>
            </div>
            <div class="test-information-header">
              <p>You can manage tests here, please add to start</p>

              <el-button
                type="text"
                class="btn radius-button add-test-btn"
                @click="popupScreen"
                :disabled="checkUser && !hasAllowedCaseType"
              >
                <span>
                  <img
                    src="@/assets/images/icons/cases/add-test.svg"
                    alt="tests-icon"
                  />
                </span>
                ADD TESTS
              </el-button>
            </div>
          </div>
        </div>
        <div class="center-error-message" v-if="isTestInfoError">
          <p class="err">
            <FormError errorName="tests_info"></FormError>
          </p>
        </div>
      </div>
      <div
        class="selected-tests-information"
        v-if="
          panelsTestsData.selectedCategories &&
          panelsTestsData.selectedCategories.length > 0 ||
          panelsTestsData.selectedGroup &&
          panelsTestsData.selectedGroup.length > 0 &&
          !addtestModelPopup &&
          !hideTestsDetails
        "
      >
        <div class="each-test-information">
          <el-checkbox-group
            v-model="panelsTestsData.selectedCategories"
            class="case-vue-tabs vue-tabs"
          >
            <el-tabs v-if="!addtestModelPopup">
              <el-tab-pane
                v-for="(test, index) of getSelectedCaseTypes()"
                :key="index"
                :class="test"
              >
                <template #label>
                  <h3 class="selected-test-title">
                    {{ index + 1 }}. {{ caseTypeMap[test.case_type_code] }}
                  </h3>
                </template>
                <div v-if="test.case_type_code == 'TOXICOLOGY'">
                  <ToxicologyTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></ToxicologyTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOUND'">
                  <WoundPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></WoundPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'NAIL'">
                  <NailPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></NailPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'GASTRO'">
                  <GastroPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GastroPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'UTI'">
                  <UTIPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UTIPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
                  <BloodPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></BloodPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'STI'">
                  <GTIWomensHealthTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GTIWomensHealthTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINALYSIS'">
                  <UrinalysisTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UrinalysisTestsPreview>
                </div>
                <div
                  v-else-if="
                    test.case_type_code == 'RESPIRATORY_PATHOGEN_PANEL'
                  "
                >
                  <RespiratoryTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></RespiratoryTestsPreview>
                </div>
                <div v-else>
                  <DefaultPanelSelectedTests
                    v-if="show"
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :testType="test"
                    :allSelectedTests="allTests"
                    :caseType="test.case_type_code"
                  ></DefaultPanelSelectedTests>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-checkbox-group>
        </div>
      </div>
      <div class="case-creation__add-test" v-if="addtestModelPopup">
        <div class="add-test-popup">
          <el-dialog
            width="90%"
            v-model="addtestModelPopup"
            :destroy-on-close="true"
          >
            <AddTests
              :panelsTestsDataUnchanged="panelsTestsData"
              :caseTypes="caseInformation.case_types"
              @addTestsData="updateTestsPanelsData"
              v-if="addtestModelPopup"
            ></AddTests>
          </el-dialog>
        </div>
      </div>
      <span class="case-creation__divider"></span>

      <!-- ! Medications Information || Case Creation -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__medication">
          <div class="medication-card">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Medications</h3>
              </div>
            </div>
            <div class="medication-content">
              <ul class="medication-block">
                <li>
                  <p class>(Note:- Add Medication One-by-one)</p>
                </li>
                <li>
                  <span class="medicine-img">
                    <img
                      src="@/assets/images/medicines.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </li>

                <li>
                  <div class="medication-search-input-lg input-with-icon">
                    <el-form @keyup.enter.prevent="addMedication()">
                      <el-form-item class="medication-form-item">
                        <el-select
                          v-model="patientMedicationFormData.value"
                          filterable
                          clearable
                          remote
                          placeholder="Search Medication"
                          :remote-method="getAutoCompleteMedicationsData"
                          :loading="medicationLoading"
                          :disabled="hasCases"
                          
                        >
                          <el-option
                            v-for="(
                              medication, index
                            ) in patientMedicationFormData.medicationsData"
                            :key="index"
                            :label="medication.drug"
                            :value="medication.drug"
                            :disabled="
                              patientMedicationFormData.options.indexOf(
                                medication.drug
                              ) != -1
                                ? true
                                : false
                            "
                          >
                            <span style="float: left">
                              {{ medication.drug }}
                            </span>
                            <span style="float: right; color: #8492a6">
                              {{ medication.is_child ? "Brand" : "" }}
                            </span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>

                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li>
                  <span>
                    <el-button
                      class="btn radius-button"
                      @click="addMedication"
                      :disabled="!patientMedicationFormData.value"
                      :loading="medicationLoading"
                      >+ ADD</el-button
                    >
                  </span>
                </li>
              </ul>

              <div class="default-modal">
                <el-dialog
                  width="25%"
                  v-model="addMedicationModelPopup"
                  @close="removeErrors"
                  :show-close="true"
                  :destroy-on-close="true"
                >
                  <div class="dialog-header">
                    <span class="header-part">
                      <img
                        src="@/assets/images/icons/cases/pills.svg"
                        alt="icon"
                      />
                      Add Medication
                    </span>
                    <el-button
                      size="medium"
                      class="el-white"
                      type="info"
                      plain
                      @click="addMedicationModelPopup = false"
                    >
                      <img
                        src="@/assets/images/icons/cases/close-btn.svg"
                        alt="icon"
                      />
                    </el-button>
                  </div>
                  <div class="default-input pb-0">
                    <el-input
                      placeholder="Enter medication"
                      v-model="formData.drug"
                      @input="formData.drug = formData.drug.toUpperCase()"
                      
                    ></el-input>
                    <p
                      class="err"
                      v-if="
                        getMedicationValidationErrors &&
                        getMedicationValidationErrors.drug
                      "
                    >
                      {{ getMedicationValidationErrors.drug }}
                    </p>
                    <div class="dialog-footer">
                      <el-button
                        class="blue-save-button"
                        @click="createMedication"
                        :disabled="buttonLoading"
                        >+ Create Medication</el-button
                      >
                    </div>
                    <p
                      class="err"
                      v-if="
                        getMedicationValidationErrors &&
                        getMedicationValidationErrors.critical_error
                      "
                    >
                      {{ getMedicationValidationErrors.critical_error }}
                    </p>
                  </div>
                </el-dialog>
              </div>
            </div>
          </div>
          <p
            class="err"
            v-if="
              getMedicationValidationErrors &&
              getMedicationValidationErrors.medication
            "
          >
            <FormError errorName="medication"></FormError>
          </p>
          <div class="medication-list-block">
            <ul>
              <li
                v-for="(medication, index) in patientMedicationFormData.options"
                :key="index"
                class="text item"
              >
                <span>{{ medication }}</span>

                <el-button
                  type="text"
                  class="minus-icon"
                  @click="removeMedication(medication)"
                  :disabled="hasCases"
                >
                  <span>
                    <img
                      src="@/assets/images/minus-button.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span
        v-if="caseInformation.billing_type == 'INSURANCE'"
        class="case-creation__divider"
      ></span>
      <!-- ! Billing Information || Case Creation -->
      <div
        class="case-creation__step case-creation__billing-information"
        v-if="caseInformation.billing_type == 'INSURANCE'"
      >
        <div class="case-creation__card">
          <div class="case-creation__heading justify-start">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Billing Information</h3>
            </div>
            <div class="billing_alignmens">
              <p class="err">
                <FormError errorName="case_data.billing_info"></FormError>
              </p>
            </div>
          </div>
          <div class="case-creation__billing-information__body">
            <div class="case-creation__tabs billing-information-tabs">
              <el-tabs v-model="activeName" @tab-click="updateSelectedTabQuery">
                <el-tab-pane name="first">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasError }"
                      >primary insurance</span
                    >
                  </template>
                  <PrimaryInsurance
                    v-if="activeName === 'first' && showInsuranceDob"
                    :caseInformation="patientInformation"
                    :primaryInsurance="primaryInsuranceForm"
                    :refreshDob="refreshPatientDob"
                    ref="primaryInsuranceForm"
                  ></PrimaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasSecondaryErrors }"
                      >Secondary Insurance</span
                    >
                  </template>
                  <SecondaryInsurance
                    v-if="activeName === 'second' && showInsuranceDob"
                    :caseInformation="patientInformation"
                    :secondaryInsurance="secondaryInsuranceForm"
                    :refreshDob="refreshPatientDob"
                    ref="secondaryInsuranceForm"
                  ></SecondaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasTertiaryErrors }"
                      >Tertiary Insurance</span
                    >
                  </template>
                  <TertiaryInsuranceForm
                    v-if="activeName === 'third' && showInsuranceDob"
                    :caseInformation="patientInformation"
                    :tertiaryInsurance="tertiaryInsuranceForm"
                    :refreshDob="refreshPatientDob"
                    ref="tertiaryInsuranceForm"
                  ></TertiaryInsuranceForm>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasGuarantorErrors }"
                      >Guarantor</span
                    >
                  </template>
                  <GuarantorInsurance
                    v-if="activeName === 'fourth' && showInsuranceDob"
                    :caseInformation="patientInformation"
                    :guarantorInsurance="guarantorInsuranceForm"
                    ref="guarantorInsuranceForm"
                  ></GuarantorInsurance>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <!-- ! Action Buttons || Case Creation -->
      <div class="case-creation__actions fixed">
        <ul class="list">
          <li>
            <el-button
              type="button"
              class="btn cancel-button"
              @click="goToAllCases"
              >Cancel</el-button
            >
          </li>
          <li>
            <el-button
              type="button"
              class="btn save-button"
              @click="createNewCase"
              >Save</el-button
            >
          </li>
        </ul>
      </div>
      <FormError errorName="case_data.critical_error"></FormError>
    </div>

    <!-- External Components -->
    <ExistingCaseDetails
      v-if="errorDiloag"
      :existedCase="existedCaseDetails"
      :caseType="caseInformation.case_types"
      :caseInformation="caseInformationDetails"
      :case="caseUpdate"
      :newCase="newCase"
      v-on:closeDialog="handleClose"
      v-on:closePopupDialog="handlePopUp"
      @newCaseCreation="newCaseCreation"
      @approveCase="approveCase"
    ></ExistingCaseDetails>

    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateCase"
    ></ResonForChange>

    <LookUpPopup
      v-if="lookupDialogVisible"
      :lookupSearchInfo="patientInformation"
      @closeLookUpPopup="handleCloseLookUpPopup"
      @selectPatientInfo="updatePatientInfo"
    ></LookUpPopup>
    <div class="default-modal" v-if="this.addressData">
      <el-dialog v-model="verifyAddressPopup">
        <div class="dialog-header">
          <span class="header-part"
            >The address you entered was found but more information is
            needed</span
          >
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="verifyAddressPopup = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="address-data-fields">
          <ul class="address-lists">
            <li>
              <p class="name">Address</p>
              <span class="value">: {{ this.addressData.Address1 }}</span>
            </li>
            <li>
              <p class="name">Zip</p>
              <span class="value">: {{ this.addressData.Zip5 }}</span>
            </li>
            <li>
              <p class="name">State</p>
              <span class="value">: {{ this.addressData.State }}</span>
            </li>
            <li>
              <p class="name">City</p>
              <span class="value">: {{ this.addressData.City }}</span>
            </li>
          </ul>
          <div class="dialog-footer">
            <el-button class="blue-save-button" @click="fillAddressData"
              >Update Address</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
import AppHelper from "@/mixins/AppHelper";
import AddTests from "@/components/cases/TestInformation";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const state = defineAsyncComponent(() =>
  import("@/components/misc/BillingState")
);
const city = defineAsyncComponent(() =>
  import("@/components/misc/BillingCity")
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
import { startLoading } from "@/helpers/loadingHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);

// billing Info
const PrimaryInsurance = defineAsyncComponent(() =>
  import("@/components/pendingCases/billingInfo/forms/PrimaryInsurance")
);
const SecondaryInsurance = defineAsyncComponent(() =>
  import("@/components/pendingCases/billingInfo/forms/SecondaryInsurance")
);
const TertiaryInsuranceForm = defineAsyncComponent(() =>
  import("@/components/pendingCases/billingInfo/forms/TertiaryInsurance")
);
const GuarantorInsurance = defineAsyncComponent(() =>
  import("@/components/pendingCases/billingInfo/forms/GuarantorInsurance")
);

const LookUpPopup = defineAsyncComponent(() =>
  import("@/components/cases/LookUpPopup")
);
import moment from "moment";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
const RespiratoryTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/RespiratoryTestsPreview")
);
export default {
  components: {
    AddTests,
    ExistingCaseDetails,
    ResonForChange,
    state,
    city,
    dobVersion,
    FormError,
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    LookUpPopup,
    GastroPanelSelectedTests,
    NailPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    RespiratoryTestsPreview,
  },
  mixins: [caseDataHelper, AppHelper, InsuranceHelper],
  data() {
    return {
      usersList: [],
      verifyAddressPopup: false,
      addressData: {},
      verifyButtonLoading: false,
      page: 1,
      pageSize: 10,
      errorDiloag: false,
      caseUpdate: false,
      newCase: false,
      refreshPatientDob: true,
      existedCaseDetails: {},
      caseInformationDetails: {},
      hideTestsDetails: false,
      filterString: "",
      takeReasonDialog: false,
      buttonLoading: false,
      loading: false,
      formData: {
        drug: "",
        group: "",
        is_child: true,
      },
      patientMedicationFormData: {
        options: [],
        medications: [],
        medicationsData: [],
        groupOptions: [],
        value: "",
        list: [],
        loading: false,
      },
      medicationLoading: false,
      lookupDialogVisible: false,
      addMedicationModelPopup: false,
      addtestModelPopup: false,
      modalLoading: false,
      activeName: "first",
      genderOptions: ["MALE", "FEMALE"],
      raceOptions: [
        "American Indian or Alaska Native",
        "Asian",
        "Black or Afrian American",
        "Native Hawalian or Other Pacific Islander",
        "White",
        "Other Race",
      ],
      ethnicityOptions: [
        "Ashkenazi Jewish",
        "Asian",
        "Black/African",
        "American",
        "Hispanic or Latino",
        "Hispanic",
        "Native American",
        "Not Hispanic or Latino",
        "Other",
        "Pacific Islander",
        "Unknown",
        "White/Caucasian",
      ],
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },

      faxInputValue: "",

      //patient information
      patientInformation: {
        first_name: "",
        middle_name: "",
        last_name: "",
        gender: "",
        date_of_birth: "",
        emr: "",
        pms_or_pws: "",
        home_phone: "",
        work_phone: "",
        email: "",
        address_line_1: "",
        address_line_2: "",
        county: "",
        city: "",
        state: "",
        zip: "",
        race: "",
        ethnicity: "",
        pregnant: false,
      },
      defaultTime: [new Date(2000, 2, 1, 10, 0, 0)],
      //case information
      caseInformation: {
        case_types: [],
        is_stat :false ,
        lab: "",
        collection_date: "",
        specimen_collector: "",
        received_date: "",
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        referring_physician: null,
        icd_10_codes: "",
        billing_type: "",
        order_id: "",
        additional_fax: [],
        additional_fax_requisite: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
        sample_types: "",
        cpt_codesForm: [
          {
            sno: 1,
            value: "81001",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
          {
            sno: 11,
            value: "",
          },
          {
            sno: 12,
            value: "",
          },
          {
            sno: 13,
            value: "",
          },
          {
            sno: 14,
            value: "",
          },
          {
            sno: 15,
            value: "",
          },
          {
            sno: 16,
            value: "",
          },
          {
            sno: 17,
            value: "",
          },
          {
            sno: 18,
            value: "",
          },
          {
            sno: 19,
            value: "",
          },
          {
            sno: 20,
            value: "",
          },
        ],
        cpt_codes: "",
      },

      search_case_types: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      selectedTab: null,
      hospitalBranches: [],
      allReferringPhysicians: [],
      show: false,
      showDob: false,
      showPatientDob: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },

      allTests: [],
      caseId: "",
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      showPatientState: false,
      showPatientCity: false,
      hospitalsData: {},
      physiciansData: {},
      sampleTypesList: "",
      selectedSampleTypes: "",
      selectedSampleTypes1: "",
      selectedSampleTypes2: "",
      showInsuranceDob: false,
      includeAllICDCodes: false,
    };
  },
  computed: {
    checkCaseValidation() {
      if (this.$route.params.case_id) {
        return false;
      }
      return true;
    },
    hasCases() {
      if (
        this.checkUser &&
        !this.hasAllowedCaseType &&
        !this.checkCaseValidation
      ) {
        return true;
      } else if (
        this.checkUser &&
        this.hasAllowedCaseType &&
        this.checkCaseValidation
      ) {
        return true;
      }
      return false;
    },
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.case_types &&
          this.getsinglePatientDetails.case_types.length
        ) {
          const cases = this.getsinglePatientDetails.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    hasAddress() {
      if (
        this.patientInformation.address_line_1 &&
        this.patientInformation.zip &&
        this.patientInformation.state &&
        this.patientInformation.city
      ) {
        return false;
      }
      return true;
    },
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    isTestInfoError() {
      if (this.getErrors && this.getErrors.tests_info) {
        return true;
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    ...mapGetters("pendingCases", [
      "getsinglePatientDetails",
      "getPatientInformationUpdateStatus",
      "getMedication",
      "getCaseInformationUpdateStatus",
    ]),
    ...mapGetters("cases", [
      "getCaseCreationStatus",
      "getMedicationCreateStatus",
      "getAllMedications",
      "getsinglePatientDetailsValidationErrorsCode",
      "getMedicationValidationErrors",
      "getStateAndCity",
      "getVerifyAddress",
      "getAllSampleTypes",
      "getAddress",
    ]),
    ...mapGetters("patients", ["getSinglePatient"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    getCaseTypeLimit() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.indexOf("COVID_FLU") != -1
      ) {
        return 1;
      }
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.indexOf("URINALYSIS") != -1
      ) {
        return 2;
      }

      return 1;
    },
    checkCaseTypeDisable() {
      return (caseType) => {
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.caseInformation.case_types.length == 2 &&
          this.caseInformation.case_types.indexOf("COVID_FLU") == -1 &&
          caseType.value == "COVID_FLU"
        ) {
          return true;
        }
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.caseInformation.case_types.length == 2 &&
          this.caseInformation.case_types.indexOf("URINALYSIS") == -1 &&
          caseType.value == "URINALYSIS"
        ) {
          return true;
        }
        return false;
      };
    },

    getCaseTypes() {
      return this.search_case_types;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    ...mapGetters("auth", ["getAuthenticatedUser","getUserPrimaryLabId"]),
    ...mapGetters("errors", ["getError", "getErrors"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("branches", ["getAllBranches"]),
    hasNoCaseTypes() {
      if (
        !this.caseInformation ||
        !this.caseInformation.case_types ||
        this.caseInformation.case_types.length === 0
      ) {
        return true;
      }
      return false;
    },
    hasCaseType() {
      if (
        (this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1) ||
        this.caseInformation.case_types.indexOf("PGX_TEST") > -1
      ) {
        return true;
      }
      return false;
    },
    isError() {
      if (this.getErrors && this.getErrors.collection_date) {
        return true;
      } else if (this.getErrors && this.getErrors.received_date) {
        return true;
      }
      return false;
    },
  },

  async mounted() {
    this.loadInitData();
  },
  methods: {
    async handlePregnancyData() {
      if (this.patientInformation.gender != "FEMALE") {
        this.patientInformation.pregnant = false;
      }
    },
    manageCaseTypes(data) {
      if (data && data.indexOf("URINALYSIS") > -1) {
        this.search_case_types = caseConstants.CASE_TYPES_DATA.filter(
          (caseType) => caseType.value != "COVID_FLU"
        );
      } else if (data && data.indexOf("COVID_FLU") > -1) {
        this.search_case_types = caseConstants.CASE_TYPES_DATA.filter(
          (caseType) => caseType.value != "URINALYSIS"
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },

    setSampleTypes() {
      this.addSpecimenCaseTypes();
    },
    async addNewSampleType(event) {
      let sampleTypes = event;
      let data = this.getAllSampleTypes.map((a) => a.sample_type.toLowerCase());

      let difference = sampleTypes.filter(
        (x) => !data.includes(x.toLowerCase())
      );
      if (difference && difference.length) {
        let params = {
          sample_type: this.changetocaptila(difference[0]),
        };

        await this.$store.dispatch("cases/createSampleTypes", params);
        this.fetchSpecimenTypes();
      }
    },
    async fetchSpecimenTypes() {
      let params = { get_all: true };
      await this.$store.dispatch("cases/fetchAllSampleTypes", params);
    },
    addSpecimenCaseTypes() {
      this.fetchSpecimenTypes();
      // this.manageCaseTypes();
      if (!this.caseInformation.sample_types) {
        this.caseInformation.sample_types = [];
      }
      if (this.caseInformation && this.caseInformation.case_types.length == 0) {
        this.caseInformation.sample_types = [];
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        this.caseInformation.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted = this.caseInformation.sample_types.find(
            (e) => e.case_type == singleCaseType
          );
          if (!caseSampleTypeExisted) {
            // let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              sample_types: [],
              // defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformation.sample_types.push(caseTypeDefaultSampleName);
          }
        });

        // we need to remove not existed

        this.caseInformation.sample_types =
          this.caseInformation.sample_types.filter((sampleTypeData) =>
            this.caseInformation.case_types.includes(sampleTypeData.case_type)
          );
      } else {
        this.caseInformation.sample_types = [];
      }
    },
    async fillAddressData() {
      if (this.addressData) {
        this.verifyAddressPopup = false;
        this.patientInformation.address_line_1 = this.addressData.Address1;
        this.patientInformation.zip = this.addressData.Zip5;
        this.patientInformation.state = this.addressData.State;
        this.patientInformation.city = this.addressData.City;
        this.$notify.success({
          title: "Success",
          message: "Verified address updated successfully",
        });
      }
    },
    async verifyAddress() {
      try {
        this.verifyButtonLoading = true;
        let params = {
          address1: this.patientInformation.address_line_1,
          address2: this.patientInformation.address_line_2,
          zip: this.patientInformation.zip,
          city: this.patientInformation.city,
          state: this.patientInformation.state,
        };
        await this.$store.dispatch("cases/fetchAddressVerification", params);
        if (
          this.getVerifyAddress &&
          this.getVerifyAddress.misMatch &&
          this.getVerifyAddress.misMatch == true
        ) {
          this.addressData = this.getVerifyAddress.data;
          this.verifyAddressPopup = true;
        } else if (this.getVerifyAddress) {
          this.$notify.success({
            title: "Success",
            message: "Address verified successfully",
          });
        } else {
          if (!this.getVerifyAddress) {
            this.$notify.error({
              title: "Error",
              message: "Address verification failed",
            });
          }
        }
        this.verifyButtonLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getStateCity() {
      try {
        let params = {
          zip: this.patientInformation.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.patientInformation.state = this.getStateAndCity.state;
          this.patientInformation.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadInitData() {
      const loading = startLoading();
      try {
        if (this.$route.params.case_id) {
          this.checkCaseInformation();
          this.show = true;
        } else {
          this.loading = false;
          this.caseForm = true;
        }

        let params = { get_all: true };
        await this.$store.dispatch("help/fetchAllStates");

        await this.$store.dispatch("labs/fetchAllLabs", params);
        this.showDob = true;
        this.showPatientDob = true;
        this.showPatientState = true;
        this.showInsuranceDob = true;
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.allReferringPhysicians =
          this.getAllPhysicians &&
          this.getAllPhysicians.data &&
          this.getAllPhysicians.data.length
            ? this.getAllPhysicians.data
            : [];
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));

        await this.getLabCaseTypes();
        this.caseInformation.lab = this.getUserPrimaryLabId;

        loading.close();
      } catch (err) {
        loading.close();
      }
    },
    handleFaxRemove(tag) {
      this.caseInformation.additional_fax.splice(
        this.caseInformation.additional_fax.indexOf(tag),
        1
      );
    },
    removeErrors() {
      this.formData = {};
      this.$store.commit(
        "cases/setMedicationValidationErrors",
        {},
        { root: true }
      );
    },
    handleInputConfirm() {
      let inputValue = this.faxInputValue;
      if (inputValue) {
        this.caseInformation.additional_fax.push(inputValue);
      }
      this.faxInputValue = "";
    },

    async getMedicationsData() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/fetchAllMedicationsData", {
          get_all: true,
        });
        this.patientMedicationFormData.medications = this.getAllMedications;
        let groupData = this.getAllMedications
          .filter((medication) => {
            if (!medication.is_child) {
              return medication.drug;
            }
          })
          .map((medication) => medication.drug);
        this.patientMedicationFormData.groupOptions = [...new Set(groupData)];
        this.loading = false;
      } catch (err) {
        this.medicationError = err;
        this.loading = false;
      }
    },
    async createMedication() {
      try {
        this.buttonLoading = true;
        this.medicationError = "";
        await this.$store.dispatch("cases/createMedicationData", this.formData);
        this.buttonLoading = false;
        if (this.getMedicationCreateStatus) {
          successNotification("Medication Created Successfully");
          this.addMedicationModelPopup = false;
          this.lookupDialogVisible = false;
          this.loading = true;

          this.patientMedicationFormData.options.push(
            this.formData.drug.toUpperCase()
          );

          this.formData.group = "";
          this.formData.drug = "";

          await this.getMedicationsData();

          this.formData = {
            drug: "",
            group: "",
            is_child: true,
          };
          this.loading = false;
        }
      } catch (err) {
        this.medicationError = err;
        this.buttonLoading = false;
      }
    },
    removeMedication(medication) {
      let testName = medication.split("_").join(" ");
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"${testName}"</b> medication ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        const index =
          this.patientMedicationFormData.options.indexOf(medication);
        if (index > -1) {
          this.patientMedicationFormData.options.splice(index, 1);
        }
      });
    },

    addMedication() {
      if (
        this.patientMedicationFormData.value.trim().length &&
        this.patientMedicationFormData.options.indexOf(
          this.patientMedicationFormData.value.trim()
        ) == -1
      ) {
        this.patientMedicationFormData.options.push(
          this.patientMedicationFormData.value.trim()
        );
      }
      this.patientMedicationFormData.medicationsData = [];
      this.patientMedicationFormData.value = "";
    },
    async getAutoCompleteMedicationsData(queryString) {
      this.medicationLoading = true;
      if (queryString && queryString.length > 1) {
        await this.$store.dispatch("cases/fetchAllMedicationsData", {
          get_all: true,
          search_string: queryString,
        });
        this.patientMedicationFormData.medicationsData = this.getAllMedications;
      } else {
        this.patientMedicationFormData.medicationsData = [];
      }
      this.medicationLoading = false;
    },
    parsePatientInfo(patientInfo) {
      let params = { ...patientInfo };
      if (!params.work_phone) delete params.work_phone;
      if (!params.middle_name) delete params.middle_name;
      if (!params.home_phone) delete params.home_phone;
      if (!params.address_line_1) delete params.address_line_1;
      if (!params.address_line_2) delete params.address_line_2;
      if (!params.race) delete params.race;
      if (!params.ethnicity) delete params.ethnicity;
      if (!params.pregnant) delete params.pregnant;
      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      if (params.date_of_birth != "") {
        params.date_of_birth = moment(params.date_of_birth).format(
          "YYYY-MM-DD"
        );
      }
      return params;
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };
      if (params.date_of_birth) {
        params.date_of_birth = moment(params.date_of_birth).format(
          "YYYY-MM-DD"
        );
      }

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },
    prepreDataFromFormData() {
      let params = this.parseCaseInfo();
      let patientInfo = this.parsePatientInfo(this.patientInformation);
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformation.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      }  else {
        params.billing_info = {};
      }
      params.patient_info = patientInfo;
      params.tests_info = this.panelsTestsData.selectedTestIds;
      params.coriell_test_panels = this.panelsTestsData.selectedCoriellPanels;
      if (this.caseInformation && this.caseInformation.case_types) {
        params.medication = this.patientMedicationFormData.options;
      }
      if (
        this.caseInformation &&
        this.caseInformation.cpt_codesForm &&
        this.caseInformation.cpt_codesForm.length
      ) {
        params.cpt_codes = this.caseInformation.cpt_codesForm
          .filter((e) => e.value)
          .map((e) => e.value);
      } else {
        params.cpt_codes = [];
      }
      params.is_stat = this.caseInformation.is_stat      
      return params;
    },
    parseCaseInfo() {
      return {
        case_types: this.caseInformation.case_types,
        lab: this.caseInformation.lab,
        collection_date: this.convertToLabUTC(
          this.caseInformation.collection_date
        ),
        received_date: this.convertToLabUTC(this.caseInformation.received_date),
        hospital: this.caseInformation.hospital,
        icd_10_codes: this.caseInformation.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformation.ordering_physician,
        referring_physician: this.caseInformation.referring_physician || null,
        hospital_branch: this.caseInformation.hospital_branch
          ? this.caseInformation.hospital_branch
          : null,
        billing_type: this.caseInformation.billing_type,
        is_stat : this.caseInformation.is_stat ,
        specimen_collector: this.caseInformation.specimen_collector
          ? this.caseInformation.specimen_collector
          : "",
        additional_fax: this.caseInformation.additional_fax,
        sample_types: this.convertSampleTypesToCapital(
          this.caseInformation.sample_types
        ),
        additional_fax_requisite: this.caseInformation.additional_fax_requisite
          ? this.caseInformation.additional_fax_requisite
          : "",
      };
    },
    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    changetocaptila(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
    async handleClose(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });

      window.location.reload();
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async newCaseCreation(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      window.location.reload();
    },
    async approveCase(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      this.loading = true;
      let params = this.prepreDataFromFormData();
      params.auto_approved = true;
      await this.$store.dispatch("cases/addNewCase", params);
      if (this.getCaseCreationStatus) {
        successNotification("New Case Created Successfully");
        this.goBack();
      } else {
        if (!this.getErrors || this.getError) {
          errorNotification("Error while creating New Case");
        }
      }
      this.loading = false;
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async createNewCase() {
      const caseId = this.$route.params.case_id;
      if (caseId) {
        this.askReason();
      } else {
        await this.addCase();
      }
    },
    async updateCase(reason) {
      try {
        this.loading = true;
        let params = { case_data: this.prepreDataFromFormData() };
        const caseId = this.$route.params.case_id;
        params.case_id = caseId;
        params.data_update_reason = reason;
        params.is_stat =this.caseInformation.is_stat
        await this.$store.dispatch(
          "pendingCases/updateCaseInformation",
          params
        );
        this.caseUpdate = true;
        if (this.getCaseInformationUpdateStatus) {
          successNotification("Case Updated Successfully");
          this.goBack();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while updating Case");
          }
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async addCase() {
      try {
        this.loading = true;
        let params = this.prepreDataFromFormData();

        await this.$store.dispatch(
          "pendingCases/updatePatientInformation",
          params
        );
        this.newCase = true;
        if (this.getPatientInformationUpdateStatus) {
          successNotification("New Case Created Successfully");
          this.goBack();
        } else if (
          this.getsinglePatientDetailsValidationErrorsCode.error_code ===
            "GENETIC_TEST_EXISTED" ||
          this.getsinglePatientDetailsValidationErrorsCode.error_code ===
            "TEST_ALREADY_EXISTED" ||
          this.getsinglePatientDetailsValidationErrorsCode.error_code ===
            "DUPLICATE_EXISTED" ||
          this.getsinglePatientDetailsValidationErrorsCode.error_code ===
            "NON_GENTIC_TEST_VALIDATE"
        ) {
          this.errorDiloag = true;
          if (
            this.getsinglePatientDetailsValidationErrorsCode.errors &&
            this.getsinglePatientDetailsValidationErrorsCode.errors
              .existed_details
          )
            this.existedCaseDetails =
              this.getsinglePatientDetailsValidationErrorsCode.errors.existed_details;
          this.caseInformationDetails = this.prepreDataFromFormData();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while creating New Case");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];

      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    goBack() {
      if (
        this.$route.params &&
        this.$route.params.case_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "AllApprovalPendingCases",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },

    async fetchAllPhysiciansByHospital(hospital) {
      this.caseInformation.ordering_physician = undefined;
      this.caseInformation.hospital_branch = null;
      let params = {
        hospital,
        get_all: true,
      };
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      await this.$store.dispatch("branches/fetchAllBranches", {
        hospital_id: hospital,
        get_all: true,
      });
      this.hospitalBranches = this.getAllBranches.data;
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      this.caseInformation.ordering_physician = undefined;

      if (hospitalBranch) {
        let params = {
          hospital_branch: hospitalBranch,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      } else {
        this.fetchAllPhysiciansByHospital(this.caseInformation.hospital);
      }
    },

    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.includeAllICDCodes == false
        ) {
          params.primary_case_types = this.caseInformation.case_types[0];
        }

        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = [];
        (this.getAllIcd10Codes.data || []).forEach((el) => {
          allIcdCodes.push({
            value: el.code + " - " + el.description,
            ...el,
          });
        });

        cb(allIcdCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.code;
      this.previousSearchString = "";
    },

    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },

    updateTestsPanelsData(event) {
      this.show = false;
      this.modalLoading = true;
      const loading = startLoading();

      if (event && event.data) {
        this.panelsTestsData.selectedTestIds = event.data.selectedTestIds;
        this.panelsTestsData.selectedCategories = event.data.selectedCategories;
        this.panelsTestsData.selectedGroup = event.data.selectedGroup;
        this.allTests = event.allTests;
      }
      setTimeout(() => {
        this.addtestModelPopup = false;
        this.show = true;
        loading.close();
      }, 500);
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el, index) => {
          if (
            el &&
            this.getTestsInformationObject[el] &&
            this.caseInformation.case_types.indexOf(
              this.getTestsInformationObject[el].case_type_code
            ) != -1
          ) {
            data.push(this.getTestsInformationObject[el]);
          } else {
            this.panelsTestsData.selectedTestIds.splice(index, 1);
          }
        });
      }

      return data;
    },
    getSelectedCaseTypes() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        let data = [...this.panelsTestsData.selectedCategories,...this.panelsTestsData.selectedGroup]
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
    goToAllCases() {
      if (
        this.$route.params &&
        this.$route.params.case_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "AllApprovalPendingCases",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },

    popupScreen() {
      this.addtestModelPopup = true;
      this.modalLoading = true;
    },
    async checkCaseInformation() {
      this.loading = true;
      this.caseId = this.$route.params.case_id;
      await this.$store.dispatch("pendingCases/fetchSingleCaseInformation", {
        case_id: this.caseId,
      });

      await this.fetchAllPhysiciansByHospital(
        this.getsinglePatientDetails.hospital._id
      );

      if (!this.getsinglePatientDetails) {
        this.disablePatientInformation = true;
      }

      if (this.getsinglePatientDetails) {
        if (this.getsinglePatientDetails.patient_info) {
          this.patientInformation = {
            ...this.getsinglePatientDetails.patient_info,
          };
        }
        this.setCaseInformationData();
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.tests_info
        ) {
          this.panelsTestsData.selectedTestIds =
            this.getsinglePatientDetails.tests_info.map((el) => el._id);
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.sample_types
        ) {
          this.caseInformation.sample_types =
            this.getsinglePatientDetails.sample_types;
        }

        if (
          this.getsinglePatientDetails.coriell_test_panels &&
          this.getsinglePatientDetails.coriell_test_panels.length
        ) {
          this.panelsTestsData.selectedCoriellPanels =
            this.getsinglePatientDetails.coriell_test_panels;
        }

        this.allTests = this.getsinglePatientDetails.tests_info;
        if (this.getsinglePatientDetails.medication) {
          this.patientMedicationFormData.options =
            this.getsinglePatientDetails.medication || [];
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.billing_info &&
          this.getsinglePatientDetails.billing_info.insurance &&
          this.getsinglePatientDetails.billing_info.insurance.primary_insurance
        ) {
          this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getsinglePatientDetails.billing_info.insurance
              .primary_insurance
          );
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.billing_info &&
          this.getsinglePatientDetails.billing_info.insurance &&
          this.getsinglePatientDetails.billing_info.insurance
            .secondary_insurance
        ) {
          this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getsinglePatientDetails.billing_info.insurance
              .secondary_insurance
          );
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.billing_info &&
          this.getsinglePatientDetails.billing_info.insurance &&
          this.getsinglePatientDetails.billing_info.insurance.tertiary_insurance
        ) {
          this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getsinglePatientDetails.billing_info.insurance
              .tertiary_insurance
          );
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.billing_info &&
          this.getsinglePatientDetails.billing_info.insurance &&
          this.getsinglePatientDetails.billing_info.insurance.guarantor
        ) {
          this.guarantorInsuranceForm =
            this.getsinglePatientDetails.billing_info.insurance.guarantor;
        }
      }

      this.loading = false;
    },
    setCaseInformationData() {
      if (
        this.getsinglePatientDetails &&
        Object.keys(this.getsinglePatientDetails) &&
        Object.keys(this.getsinglePatientDetails).length
      ) {
        this.caseInformation.case_types =
          this.getsinglePatientDetails.case_types;
        this.caseInformation.lab = this.getsinglePatientDetails.lab
          ? this.getsinglePatientDetails.lab._id
          : null;
        this.caseInformation.collection_date = this.convertLabUTCToClient(
          this.getsinglePatientDetails.collection_date
        );
        this.caseInformation.received_date = this.convertLabUTCToClient(
          this.getsinglePatientDetails.received_date
        );
        this.caseInformation.hospital = this.getsinglePatientDetails.hospital
          ? this.getsinglePatientDetails.hospital._id
          : null;
        this.caseInformation.ordering_physician =
          this.getsinglePatientDetails.ordering_physician._id;
        this.caseInformation.referring_physician =
          this.getsinglePatientDetails.referring_physician &&
          this.getsinglePatientDetails.referring_physician._id
            ? this.getsinglePatientDetails.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getsinglePatientDetails
          .hospital_branch
          ? this.getsinglePatientDetails.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes =
          this.getsinglePatientDetails.icd_10_codes;
        this.caseInformation.billing_type =
          this.getsinglePatientDetails.billing_type;
        this.caseInformation.order_id =
          this.getsinglePatientDetails.order_id || "";
        this.caseInformation.specimen_collector =
          this.getsinglePatientDetails.specimen_collector;
        this.caseInformation.patient_info =
          this.getsinglePatientDetails.patient_info;

        this.caseInformation.icd_10_codes.forEach((el, index) => {
          this.caseInformation.icd_10_codesForm[index].value = el;
        });

        this.caseInformation.additional_fax =
          this.getsinglePatientDetails.additional_fax &&
          this.getsinglePatientDetails.additional_fax.length
            ? this.getsinglePatientDetails.additional_fax
            : [];
        this.caseInformation.additional_fax_requisite = this
          .getsinglePatientDetails.additional_fax_requisite
          ? this.getsinglePatientDetails.additional_fax_requisite
          : "";
        this.caseInformation.cpt_codes = this.getsinglePatientDetails.cpt_codes;
        this.caseInformation.cpt_codes.forEach((el, index) => {
          this.caseInformation.cpt_codesForm[index].value = el;
        });
      }
    },
    openLookUpDialog() {
      const dobField = this.$refs["dobField"];

      if (
        !this.patientInformation.date_of_birth &&
        (dobField.dob_date || dobField.dob_year || dobField.dob_month)
      ) {
        this.$message({
          message: "Please select valid DOB!",
          type: "warning",
        });
        this.loading = false;
        this.tableVisible = false;

        return null;
      }

      const info = this.patientInformation;
      if (
        Object.keys(
          info.first_name ||
            info.last_name ||
            info.middle_name ||
            info.gender ||
            info.date_of_birth
        ).length < 1
      ) {
        this.$message({
          message: "Please select an option to search!",
          type: "warning",
        });

        return null;
      }

      if (this.patientInformation.date_of_birth) {
        var input = this.patientInformation.date_of_birth;
        if (input.length) {
          var date = moment(input);
          if (!date.isValid()) {
            this.$message({
              message: "Invalid DOB!",
              type: "warning",
            });

            return null;
          }
        }
      }
      this.lookupDialogVisible = false;
      setTimeout(() => {
        this.lookupDialogVisible = true;
      }, 100);
    },
    handleCloseLookUpPopup() {
      this.lookupDialogVisible = false;
    },
    setPatientInsuranceData(data) {
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.primary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.primary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.secondary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.secondary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.tertiary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.guarantor
      ) {
        this.showInsuranceDob = false;
        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.guarantorInsuranceForm = data.billing_info.insurance.guarantor;
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.medication &&
        data.medication.length != 0
      ) {
        this.patientMedicationFormData.options = data.medication;
      } else {
        this.patientMedicationFormData.options = [];
      }
    },
    updatePatientInfo(selectedPatientData) {
      this.setPatientInsuranceData(selectedPatientData);
      this.showPatientDob = false;
      this.showPatientState = false;
      this.patientInformation = {
        ...this.patientInformation,
        ...selectedPatientData.patient_info,
      };
      this.lookupDialogVisible = false;
      this.showPatientState = true;

      this.showPatientDob = true;
    },
  },
  watch: {
    "caseInformation.case_types": {
      immediate: true,
      handler: function () {
        // this.setSampleTypes();
        this.hideTestsDetails = true;
        setTimeout(() => {
          this.hideTestsDetails = false;
        }, 1000);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
//Addtional Fax start
.vue-form {
  .mobile-icon {
    position: relative;

    .el-icon {
      position: absolute;
      right: 2%;
      top: 38%;
      opacity: 0.3;
    }
  }

  .additonal-fax {
    display: flex;
    gap: 20px;
  }

  .fax-btn {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .el-button {
      padding: 0 14px;

      min-height: 30px;
      background-color: #273480;
      color: #ffffff;
      border: none;
    }

    .fax-actions-view {
      display: flex;
      flex-wrap: wrap;

      margin: 0 10px;

      .el-tag {
        margin: 3px;
        padding: 0 5px 0 10px;
        border: none;
        height: 28px;
        font-weight: 500;
        border-radius: 12.7979px;
        line-height: 28px;
        background: #e7eff6;
        color: #0a5da6;
      }

      .btn-close-icon {
        display: flex;
        align-items: center;

        img {
          position: relative;
          top: 1px;
          cursor: pointer;
        }
      }
    }
  }
}

.empty-test-inner {
  margin-top: 5em;
  margin-bottom: 5em;
  text-align: center;

  .test-info {
    margin: 0 auto;

    img {
      width: 115px;
      margin: 10px;
    }
  }

  .content {
    text-align: center;

    p {
      color: #828282;
      line-height: 22px;
      font-size: 14px;
    }

    .el-button {
      margin: 14px 0;

      background: #0a5da6 !important;
      box-shadow: 0px 8px 16px -4px rgba(16, 38, 137, 0.1);
      border-radius: 10px;
      color: #fff;
      border: 0.7px solid #0a5da6;
    }
  }
}

//medication reomve start
.lists {
  margin: 0;
  display: flex;
  justify-content: flex-start;

  .remove-btn {
    .el-button {
      border: none;
      padding: 0;
      min-height: 20px;

      &:hover {
        background: none;
      }

      &:active {
        background: none;
      }

      &:focus {
        background: none;
      }
    }

    .el-dialog--center {
      border-radius: 5px;

      .el-dialog__body {
        text-align: initial;
        padding: 17px calc(var(--el-dialog-padding-primary) + 25px) 10px;
        text-align: center;

        span {
          img {
            vertical-align: top;
          }

          .view-cases {
            color: #0a5da6;
          }
        }
      }

      .el-dialog__footer {
        .dialog-footer {
          .el-button {
            border: 1.3px solid #dedbdb;
            color: #4f4f4f;
            padding: 5px;
            border-radius: 5px;

            &:hover {
              background-color: #f24a55;
              color: #fff;
              // border: none;
            }
          }

          .el-button--primary {
            background: none;
            padding: 5px 20px;

            &:hover {
              background-color: #215fad;
              color: #fff;
              // border: none;
            }
          }
        }
      }
    }

    .el-dialog__header {
      display: none;
    }
  }
}

//medication reomve end
.active-case-type-error {
  margin-top: 25px !important;
}

.active-tabs {
  color: #eb5757;
  font-weight: 500;
}
</style>
